// SessionTimeoutDisplay.js
import React from 'react';
import Typography from '@mui/material/Typography';

const SessionTimeoutDisplay = ({ timer }) => {
    // Ensure we have a non-negative number
    const totalSeconds = Math.max(0, timer ?? 0);

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.ceil(totalSeconds % 60);

    const hoursString = String(hours).padStart(2, '0');
    const minutesString = String(minutes).padStart(2, '0');
    const secondsString = String(seconds).padStart(2, '0');

    // Same behavior as before: flag when < 120 seconds
    const outOfTime = totalSeconds < 120;

    return (
        <Typography
            variant="h7"
            id="timeout_session_046"
            sx={{
                color: outOfTime ? 'white' : '#06152B',
                background: outOfTime ? 'red' : 'white',
                px: 2,
            }}
        >
            Time out:[{hoursString}:{minutesString}:{secondsString}]
        </Typography>
    );
};

export default SessionTimeoutDisplay;
